import { SimpleGrid, Stack, Text } from '@mantine/core';
import type { ReactNode } from 'react';

import { CopyableText } from '../CopyableText';

export function DetailField({
    label,
    value,
    copyValue,
}: {
    label: string;
    value: ReactNode;
    /** Clipboard value; string `value` is copied automatically when omitted */
    copyValue?: string;
}) {
    const resolvedCopy =
        copyValue ??
        (typeof value === 'string' && value !== '—' ? value : undefined);

    return (
        <Stack gap={4}>
            <Text size="xs" tt="uppercase" fw={600} c="dimmed">
                {label}
            </Text>
            {resolvedCopy?.trim() ? (
                <CopyableText copyValue={resolvedCopy} label={label} size="sm">
                    {value ?? '—'}
                </CopyableText>
            ) : value != null && typeof value !== 'string' ? (
                value
            ) : (
                <Text size="sm">{value ?? '—'}</Text>
            )}
        </Stack>
    );
}

export function DetailFieldGrid({ children }: { children: ReactNode }) {
    return (
        <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
            {children}
        </SimpleGrid>
    );
}
